<template>
	<div class="transitionParent05 "
		:class="useUserStore().isHover ? 'sidebarBloStyPar ' : 'positionS left0 top0 zIndex998'">
		<!-- 20260109 新增换种方式处理侧边栏鼠标离开事件  @mouseover.stop="mouseLeaveCollapse()" -->
		<div class="isMaskSty heightPercentage positionA top0 left0 back_0005 "
			:class="(isMask || useUserStore().isFixed ? 'widthVw' : 'width0') + (useUserStore().isHover ? '' : ' backNone')">
		</div>

		<!-- 悬浮时弹窗展示 v-if="!useUserStore().isCollapse" -->
		<!-- 20260109 新增换种方式处理侧边栏鼠标离开事件 @mouseleave.stop="mouseLeaveCollapse()" -->
		<div @mouseleave.stop="mouseLeaveCollapse()" class="sidebarBloSty noPrint positionA zIndex998 "
			:class="(useUserStore().isHover ? 'width244' : 'width64') + (useUserStore().isCollapse ? ' opacity0' : ' opacity1')">
			<div v-if="sidebarObj" class="sidebarObjBlo">
				{{sidebarObj.name}}
			</div>

			<div v-if="useUserStore().isHover"
				class="positionA heightPercentage displayFCenter top0 rightR12 zIndex10 color_FFF">
				<div @click="setIsCollapse()" class="isExpandSty"
					:class="isMixed ? 'isExpandStyIsMixed' : 'isExpandStyBack'">
					<img :src="isMixed ? initThemeImg('blend', 'icon_is_expand_g@2x') : initThemeImg(theme, 'icon_is_expand_g@2x')"
						alt="" class="isExpandIcon displayB transition05"
						:class="useUserStore().isHover ? 'transform180' : 'transform360'" />
				</div>
			</div>

			<div class="menuBloSty">
				<el-menu v-if="(sidebarPathNew || $route.path) && sidebarType" @select="selectHandle"
					@open="openHandle($event, 'isHover')" @close="closeHandle($event, 'isHover')"
					background-color="none" class="el-menu-vertical-demo" :default-openeds="defaultOpeneds"
					:default-active="sidebarPathNew || $route.path" :router="false" :key="menuHoverKey">
					<div v-for="(item, i) in sidebarData" :key="i">
						<el-menu-item v-if="(!item.children || (item.children && item.children.length == 0))"
							:index="item.path || ''">
							<template #title>
								<div class="displayF12Center">
									<img :src="initThemeImg(theme, item.icon)" alt="" class="img">
									<img :src="initThemeImg(theme, item.iconLight)" alt="" class="imgHover">
									<span>{{item.name}}</span>
								</div>
							</template>
						</el-menu-item>

						<div v-else @click="selectHandle(item.path || '')">
							<el-sub-menu :index="i + ''" append-to-body
								:popper-class="item.children && item.children.length > 0 ? '' : 'elMenuItemGroup'">
								<template #title>
									<div class="displayF12Center">
										<img :src="initThemeImg(theme, item.iconLight)" alt=""
											:style="!(item.children && item.children.length > 0) && (sidebarPathNew || $route.path) == item.path ? 'display: block;' : ''"
											class="imgHover">
										<img :src="initThemeImg(theme, item.icon)" alt=""
											:style="!(item.children && item.children.length > 0) && (sidebarPathNew || $route.path) == item.path ? 'display: none;' : ''"
											class="img">

										<span>{{item.name}}</span>
									</div>
								</template>
								<el-menu-item-group v-if="item.children && item.children.length > 0">
									<el-menu-item v-for="(items, index) in item.children" :index="items.path || ''">
										<div class="displayF4Center">
											{{items.name}}
											<span v-show="items.name == '设备审批'"
												:class="approvalNum != 0 ? 'color_D24' : 'color_FFF'">（{{approvalNum}}）</span>
										</div>
									</el-menu-item>
								</el-menu-item-group>
							</el-sub-menu>
						</div>
					</div>
				</el-menu>
			</div>
		</div>

		<div v-if="!useUserStore().isHover" class="sidebarBloSty noPrint "
			:class="useUserStore().isCollapse ? 'width244' : 'width64'">
			<div v-if="sidebarObj" class="sidebarObjBlo">
				{{sidebarObj.name}}
				<!-- v-if="isCollapse"  @click.stop="setIsCollapse()" @mouseover.stop="mouseoverCollapse()" -->
				<!-- <div :class="useUserStore().isCollapse ? 'widthPercentage opacity1' : 'width0 opacity0'">
					{{sidebarObj.name}}
				</div> -->

				<!-- <img v-else @click.stop="setIsCollapse()" @mouseover.stop="setIsCollapse('hover', true)"
					:src="initThemeImg(theme, sidebarObj.iconShow)" alt="" class="imgWH16"> -->

				<!-- <img v-if="isCollapse" @click.stop="setIsCollapse()" @mouseover.stop="setIsCollapse('hover', true)"
					:src="initThemeImg(theme, sidebarObj.iconShow)" alt="" class="imgWH16">
					
				<img v-else @click.stop="setIsCollapse()" @mouseover.stop="setIsCollapse('hover', true)"
					:src="initThemeImg(theme, sidebarObj.iconShow)" alt="" class="imgWH16"> -->
			</div>

			<div v-if="!useUserStore().isHover"
				class="positionA heightPercentage displayFCenter top0 rightR12 zIndex10 color_FFF">
				<div @mouseover.stop="mouseoverCollapse()" class="displayFCenter heightPercentage9 "
					:class="useUserStore().isCollapse ? '' : 'cursor'">
					<div @click="setIsCollapse()" class="isExpandSty "
						:class="isMixed ? 'isExpandStyIsMixed' : 'isExpandStyBack'">
						<img :src="isMixed ? initThemeImg('blend', 'icon_is_expand_g@2x') : initThemeImg(theme, 'icon_is_expand_g@2x')"
							alt="" class="isExpandIcon displayB transition05"
							:class="useUserStore().isCollapse ? 'transform180' : 'transform360'" />
					</div>
				</div>
			</div>

			<div class="menuBloSty">
				<!-- v-if="sidebarPath && sidebarType" 20250731注释 个别页面会出现微微闪动（解决闪动后 展开收起功能无法及时更新*） -->
				<!-- 20260105注释 :collapse="!isCollapse"  -->
				<el-menu v-if="(sidebarPathNew || $route.path) && sidebarType" @select="selectHandle" @open="openHandle"
					@close="closeHandle" background-color="none" class="el-menu-vertical-demo"
					:default-openeds="defaultOpeneds" :default-active="sidebarPathNew || $route.path" :router="false"
					:key="menuKey">
					<div v-for="(item, i) in sidebarData" :key="i">
						<!--  20260105注释&& isCollapse -->
						<el-menu-item v-if="(!item.children || (item.children && item.children.length == 0))"
							:index="item.path || ''">
							<template #title>
								<div class="displayF12Center">
									<img :src="initThemeImg(theme, item.icon)" alt="" class="img">
									<img :src="initThemeImg(theme, item.iconLight)" alt="" class="imgHover">

									<!--  20260105注释v-if="isCollapse" -->
									<span>{{item.name}}</span>
								</div>
							</template>
						</el-menu-item>

						<!-- @click="routerHandle(item.path || '', item.children && item.children.length > 0 ? '' : 1)" -->
						<div v-else @click="selectHandle(item.path || '')">
							<el-sub-menu :index="i + ''" append-to-body
								:popper-class="item.children && item.children.length > 0 ? '' : 'elMenuItemGroup'">
								<template #title>
									<div class="displayF12Center">
										<img :src="initThemeImg(theme, item.iconLight)" alt=""
											:style="!(item.children && item.children.length > 0) && (sidebarPathNew || $route.path) == item.path ? 'display: block;' : ''"
											class="imgHover">
										<img :src="initThemeImg(theme, item.icon)" alt=""
											:style="!(item.children && item.children.length > 0) && (sidebarPathNew || $route.path) == item.path ? 'display: none;' : ''"
											class="img">

										<!--  20260105注释v-if="isCollapse" -->
										<span>{{item.name}}</span>
									</div>
								</template>
								<el-menu-item-group v-if="item.children && item.children.length > 0">
									<!-- @click="selectHandle(items.path || '')" 20250807 注释 -->
									<el-menu-item v-for="(items, index) in item.children" :index="items.path || ''">
										<div class="displayF4Center">
											{{items.name}}
											<span v-show="items.name == '设备审批'"
												:class="approvalNum != 0 ? 'color_D24' : 'color_FFF'">（{{approvalNum}}）</span>
										</div>
									</el-menu-item>
								</el-menu-item-group>
							</el-sub-menu>
						</div>
					</div>
				</el-menu>
			</div>
		</div>
	</div>
</template>

<script setup>
	import {
		initThemeImg,
		setMessageQueue,
		getLeftMenuList,
		getIsMixed,
		sysmenupowerPowerInApi
	} from '@/utils/common.js'
	import defaultSettings from '@/settings'
	import useUserStore from '@/store/modules/user.js'
	const {
		proxy
	} = getCurrentInstance()
	const router = useRouter()
	const route = useRoute()
	const props = defineProps({
		sidebarType: {
			type: String,
			default: ''
		},
		sidebarPath: {
			type: String,
			default: ''
		},
		isPublicity: {
			type: Boolean,
			default: false
		} // 通过公告状态 => 判断当前页面是否重新加载了（主要监听已缓存的页面）
	})
	// 主题色--默认亮色
	const theme = computed(() => {
		return useUserStore().theme
	})
	// 设备审核--审核中数量
	const approvalNum = computed(() => {
		return useUserStore().approvalNum
	})
	// 0, 1, 2, 3, 4, 5 默认展开所有菜单
	const defaultOpeneds = computed(() => {
		return useUserStore().defaultOpeneds
	})
	const sidebarObj = computed(() => {
		return useUserStore().sidebarObj
	}) // 获取菜单 对应标题+图标
	const sidebarData = computed(() => {
		return useUserStore().sidebarObj.children || []
	}) // 菜单数据
	const isHover = computed(() => {
		return useUserStore().isHover
	}) // 遮罩层
	const userConfigData = computed(() => {
		return useUserStore().userConfigData
	}) // 配置数据
	const isMixed = computed(() => {
		return getIsMixed(route.path)
	}) // 配置数据
	const menuKey = computed(() => {
		return useUserStore().menuKey
	}) // 实现强制刷新菜单
	const jumpOpenUrl = computed(() => {
		return defaultSettings.officialWebsiteJumpLinkHelp
	})

	const sidebarPathNew = ref('')
	const selectPath = ref([route.path]) // 连续点击两次相同的菜单

	const isMask = ref(false)

	watch(() => useUserStore().isHover, val => {
		if (val) {
			isMask.value = true
		} else {
			if (!useUserStore().isCollapse) {
				isMask.value = true
				setTimeout(() => {
					isMask.value = false
				}, 500)
			} else {
				isMask.value = false
			}
		}

		// // 不是悬浮 不是展开时
		// if (!val && !useUserStore().isCollapse) {
		// 	// isMask.value = true
		// 	setTimeout(() => {
		// 		isMask.value = false
		// 	}, 5000)
		// } else {
		// 	isMask.value = false
		// }
	}, {
		// deep: true,
		immediate: true
	})

	// 收起并且只有一级时跳转
	function routerHandle(path, isChild) {
		// console.log(path, isChild, 'propspropspropsprops')
		if (isChild) {
			if (!path) {
				setMessageQueue('info', '页面待开发，二期计划')
			} else {
				router.push(path)
			}
		}
	}

	// 展开菜单
	function openHandle(e, type) {
		let arr = JSON.parse(JSON.stringify(useUserStore().defaultOpeneds))
		if (useUserStore().defaultOpeneds.indexOf(e + '') === -1 && !isNaN(e)) {
			arr.push(e.toString())
		}

		useUserStore().defaultOpeneds = [...arr].sort((a, b) => a - b);

		if (type === 'isHover') {
			useUserStore().menuKey++
		}
		// console.log(e, useUserStore().defaultOpeneds, 'openHandle')
	}

	// 收起菜单
	function closeHandle(e, type) {
		if (!isNaN(e)) {
			let index = useUserStore().defaultOpeneds.findIndex(val => {
				return val === (e + '')
			})

			if (index > -1) {
				useUserStore().defaultOpeneds.splice(index, 1)
			}

			if (type === 'isHover') {
				useUserStore().menuKey++
			}

			// console.log(e, useUserStore().defaultOpeneds, 'closeHandle')
		}
	}

	// // 选择菜单(自动/手动)
	// function selectHandle(e) {
	// 	console.log(e, 'selectHandle')
	// 	if (!e) {
	// 		setMessageQueue('info', '页面待开发，二期计划')
	// 	} else {
	// 		// selectPath.value.push(e)

	// 		// let len = selectPath.value.length

	// 		// if (len > 1) {
	// 		// 	if (selectPath.value[len - 1] === selectPath.value[len - 2]) {
	// 		// 		// 调用接口 重置详情路径
	// 		// 		selectPath.value = []
	// 		// 		console.log('调用接口 重置详情路径')
	// 		// 	}
	// 		// } else {
	// 		// 	console.log(selectPath.value, 'selectPath.value')
	// 		// }
	// 	}
	// }

	const menuHoverKey = ref(0)
	// 选择菜单(自动/手动) 路由跳转页面不存在 跳回到首页并且强制刷新当前系统
	async function selectHandle(path) {
		if (path) {
			// 使用帮助-更新日志 跳转新页（云联智办OFC预览页）
			if (path === '/updateExplanation') {
				// 实现强制刷新菜单
				useUserStore().menuKey = Date.now();
				window.open(jumpOpenUrl.value + 'ofc9')
				return
			}
			
			// 检查权限
			const data = await sysmenupowerPowerInApi(path)
			// console.log(data, 'datadatadatadata')
			const code = data.code
			if (data.code === 200) {
				useUserStore().isHover = false
				// 悬浮弹窗收起
				mouseLeaveCollapse()
				router.push(path)
			} else {
				useUserStore().isHover = false
				// 实现强制刷新菜单
				useUserStore().menuKey = Date.now();
			}
		}
	}

	// const isClick = ref(false) // 点击展开收起
	// const isHover = ref(false) // 悬浮
	// const isCollapse = ref(window.innerWidth <= 1440 ? false : true)
	// const isCollapse = ref(true)
	const timeOut = ref(null)
	// 获取侧边栏展示收起状态
	function resizeHandlerSider() {
		clearTimeout(timeOut.value)
		timeOut.value = setTimeout(() => {
			// 根据侧边栏展开收起
			// getIsCollapse()
			// console.log(window.innerWidth, 'window.innerWidth')
		}, 20)
	}

	const timeOutVal = ref(null)

	// 点击展开收起
	function setIsCollapse() {
		// 判断当前是否为固定状态
		if (useUserStore().isHover) {
			useUserStore().isFixed = true
			setTimeout(() => {
				useUserStore().isFixed = false
			}, 500)
		}

		// 清除图标悬浮显示延时器
		clearTimeoutTime()

		// // 已经悬浮了 不能点击展开 可以点击关闭
		// if (useUserStore().isHover) {
		// 	if (useUserStore().isCollapse) {
		// 		useUserStore().isClick = false
		// 		useUserStore().isCollapse = false
		// 		useUserStore().isHover = false
		// 	}

		// 	return
		// }

		// 悬浮时点击关闭 => 再点击展开
		if (!useUserStore().isCollapse && !useUserStore().isClick) {
			useUserStore().isClick = true
		}

		// 正常情况下 点击
		useUserStore().isClick = !useUserStore().isClick

		// 正常情况下 展示收起
		useUserStore().isCollapse = !useUserStore().isCollapse

		console.log(useUserStore().isClick, useUserStore().isCollapse, 'useUserStore().isClick, useUserStore().isCollapse')

		// 解决表格时 样式不及时更新问题 需都组件加 ref="parentRef"
		if (proxy.$parent.$refs.parentRef && proxy.$parent.$refs.parentRef.style) {
			if (useUserStore().isCollapse) {
				// 20260105暂时注释
				// proxy.$parent.$refs.parentRef.style.maxWidth = 'calc(100% - 244px)'
			} else {
				proxy.$parent.$refs.parentRef.style.maxWidth = '100%' // 64px
			}
		}
	}

	// 清除图标悬浮显示延时器
	function clearTimeoutTime() {
		clearTimeout(timeOutVal.value)
		timeOutVal.value = null
		useUserStore().isHover = false
	}

	// 悬浮弹窗展示
	function mouseoverCollapse() {
		// console.log(useUserStore().isClick, useUserStore().isCollapse,
		// 	'useUserStore().isClick, useUserStore().isCollapse mouseoverCollapse')
		// 20260114 新增功能 固定时无悬浮功能
		if (userConfigData.value.sideModel === 'sideFixed') {
			return
		}

		if (!useUserStore().isClick) {
			return
		}

		// 清除图标悬浮显示延时器
		clearTimeoutTime()

		timeOutVal.value = setTimeout(() => {
			useUserStore().isHover = true
			menuHoverKey.value++

			// useUserStore().isCollapse = true
			// alert(useUserStore().isHover)
		}, 300)
	}

	// 悬浮弹窗收起  @mouseleave.prevent="mouseLeaveCollapse()"
	function mouseLeaveCollapse(val) {
		// if (useUserStore().isClick) {
		// 	clearTimeout(timeOutVal.value)
		// 	timeOutVal.value = null

		// 	useUserStore().isHover = false
		// 	// useUserStore().isCollapse = false
		// }

		// 为true时 不调用
		if (val) {
			return
		}

		// 清除图标悬浮显示延时器
		clearTimeoutTime()
	}

	// // 根据侧边栏展开收起
	// function getIsCollapse() {
	// 	// console.log(window.innerWidth, 'window.innerWidth')
	// 	if (window.innerWidth <= 1440) {
	// 		isCollapse.value = false
	// 		// 解决表格时 样式不及时更新问题 需都组件加 ref="parentRef"
	// 		if (proxy.$parent.$refs.parentRef && proxy.$parent.$refs.parentRef.style) {
	// 			proxy.$parent.$refs.parentRef.style.maxWidth = 'calc(100% - 64px)'
	// 		}
	// 	} else {
	// 		isCollapse.value = true
	// 		// 解决表格时 样式不及时更新问题 需都组件加 ref="parentRef"
	// 		if (proxy.$parent.$refs.parentRef && proxy.$parent.$refs.parentRef.style) {
	// 			proxy.$parent.$refs.parentRef.style.maxWidth = 'calc(100% - 244px)'
	// 		}
	// 	}
	// }

	// 获取动态左侧菜单+标题（公共方法） 20250731 新增
	function getLeftMenuListDataCommon() {
		// 要查询的url
		let menuUrl = sidebarPathNew.value || route.path
		const arrNum = ['0', '1', '2', '3', '4', '5']

		if (JSON.stringify(sidebarObj.value) === '{}') {
			if (menuUrl) {
				useUserStore().defaultOpeneds = arrNum
				// 获取动态左侧菜单+标题
				getLeftMenuListData(menuUrl)
			}
		} else {
			if (sidebarData.value.length > 0) {
				let num = 0
				sidebarData.value.map(item => {
					if (item.path === menuUrl) {
						num++
					}

					if (item.children && item.children.length > 0) {
						item.children.map(items => {
							if (items.path === menuUrl) {
								num++
							}
						})
					}
				})
				// console.log(num, 'numnumnumnumnum')
				if (num === 0) {
					useUserStore().defaultOpeneds = arrNum
					// 获取动态左侧菜单+标题
					getLeftMenuListData(menuUrl)
				}
			}
		}
	}

	// 获取动态左侧菜单+标题
	async function getLeftMenuListData(menuUrl) {
		const res = await getLeftMenuList(menuUrl)
		if (res) {
			const data = res.data
			if (data) {
				useUserStore().sidebarObj = data
			}
		}
	}

	// 1、通用方法 监听路由跳转 获取最新左侧菜单
	watch(() => router, val => {
		// // 根据页面不同路由 获取对应菜单数据（未来改成接口形式）
		// sidebarTypeSwitchData(val)
		// // 根据页面不同路由 获取对应标题+图标（未来改成接口形式）
		// sidebarTypeSwitchObj(val)

		if (route.path !== props.sidebarPath) {
			sidebarPathNew.value = props.sidebarPath
			// console.log(11111, props.sidebarPath, 'sidebarPathNew.value ')
		} else {
			sidebarPathNew.value = ''
		}

		// 获取动态左侧菜单+标题（公共方法） 20250731 新增
		getLeftMenuListDataCommon()
		// console.log(props.sidebarPath, route.path, sidebarPathNew.value, selectPath.value, 'watch router111')
	}, {
		// deep: true,
		immediate: true
	})

	// 2、补充方法 监听公告显示隐藏 获取最新左侧菜单
	watch(() => props.isPublicity, val => {
		if (val) {
			// 获取动态左侧菜单+标题（公共方法） 20250731 新增
			getLeftMenuListDataCommon()
		}
		// console.log(val, 'watch props.isPublicity')
	}, {
		// deep: true,
		immediate: true
	})

	// watch(() => props.sidebarType, val => {
	// 	console.log('watch props.sidebarType', val, useUserStore().sidebarType)
	// 	// 切换不同类型时 重置菜单展开收起项为默认全部展开
	// 	if (val && props.sidebarType !== useUserStore().sidebarType) {
	// 		useUserStore().defaultOpeneds = [0, 1, 2, 3, 4, 5]
	// 	}
	// 	console.log(props.sidebarType, useUserStore().sidebarType, props.sidebarType !== useUserStore()
	// 		.sidebarType, useUserStore().defaultOpeneds, 'watch sidebarType')

	// 	// 根据页面不同类型 获取对应菜单数据
	// 	sidebarTypeSwitchData(val)
	// 	// 根据页面不同类型 获取对应标题+图标
	// 	sidebarTypeSwitchObj(val)
	// }, {
	// 	// deep: true,
	// 	immediate: true
	// })

	watch(() => props.sidebarPath, val => {
		// console.log(val, props.sidebarType, useUserStore().defaultOpeneds, 'watch props.sidebarPath')
	}, {
		// deep: true,
		immediate: true
	})

	onMounted(() => {
		// console.log(11111 + 'onMounted selectPath', selectPath.value)
		// 根据侧边栏展开收起
		// getIsCollapse()
		// 在窗口大小改变时执行的代码
		window.addEventListener('resize', resizeHandlerSider, false)
	})

	onUnmounted(() => {
		window.removeEventListener('resize', resizeHandlerSider, false)
		clearTimeout(timeOut.value)
		timeOut.value = null
	})

	// 根据页面不同类型 获取对应菜单数据
	function sidebarTypeSwitchData(val) {
		let arr = []
		if (val === 'myMess') {
			arr = [{
				name: '账号信息',
				path: '/accountMessPage',
				icon: 'icon_zhxx_g@2x',
				iconLight: 'icon_zhxx_h@2x'
			}, {
				name: '实名认证',
				path: '/realNameAuthentication',
				icon: 'icon_smrz_g@2x',
				iconLight: 'icon_smrz_h@2x'
			}, {
				name: '收支明细',
				path: '/incomeAndExpenditureDetails',
				icon: 'icon_szmx_g@2x',
				iconLight: 'icon_szmx_h@2x'
			}, {
				name: '队列数传',
				path: '',
				icon: 'icon_dlsc_g@2x',
				iconLight: 'icon_dlsc_h@2x',
				children: [{
					name: '导出队列',
					path: '/exportQueuePage',
				}, {
					name: '上传队列',
					path: '/uploadQueuePage',
				}]
			}, {
				name: '安全设置',
				path: '/securitySettingPage',
				icon: 'icon_aqsz_g@2x',
				iconLight: 'icon_aqsz_h@2x'
			}]
		} else if (val === 'groupAccount') {
			arr = [{
				name: '成员信息',
				path: '/memberAccount',
				icon: 'icon-cyzhgl@2x',
				iconLight: 'icon-cyzhgl-select@2x'
			}, {
				name: '部门管理',
				path: '/departmentManagement',
				icon: 'icon-bmgl@2x',
				iconLight: 'icon-bmgl-select@2x'
			}, {
				name: '企业信息',
				path: '/companyInformation',
				icon: 'icon-qyxx@2x',
				iconLight: 'icon-qyxx-select@2x'
			}, {
				name: '企业文化墙',
				path: '', // /corporateCultureWall
				icon: 'icon_qywhq_g@2x',
				iconLight: 'icon_qywhq_h@2x'
			}, {
				name: '变更日志',
				path: '/changeLogs',
				icon: 'icon-bgrz@2x',
				iconLight: 'icon-bgrz-select@2x'
			}, {
				name: '集团配置',
				path: '/groupConfiguration',
				icon: 'icon-jtpz@2x',
				iconLight: 'icon-jtpz-select@2x'
			}]
		} else if (val === 'archive') {
			arr = [{
				name: '档案类别',
				path: '',
				icon: 'icon_dalb_g@2x',
				iconLight: 'icon_dalb_h@2x',
				children: [{
					name: '成员档案',
					path: '/memberArchive',
					type: 'archive_member_type',
				}, {
					name: '综合档案',
					path: '/generalArchive',
					type: 'archive_overall_type',
				}, {
					name: '到期预警',
					path: '/expirationWarning',
					type: 'archive_warning_type',
				}]
			}, {
				name: '设备登记',
				path: '/',
				icon: 'icon_sbdj_g@2x',
				iconLight: 'icon_sbdj_h@2x',
				children: [{
					name: '设备登记',
					path: '/equipmentRegistration',
					type: 'archive_device_register_type',
				}, {
					name: '设备审批',
					path: '/equipmentApproval',
					type: 'archive_device_approve_type',
				}]
			}, {
				name: '档案配置',
				path: '/archiveSetting',
				icon: 'icon_dapz_g@2x',
				iconLight: 'icon_dapz_h@2x'
			}]
		} else if (val === 'toolbox') {
			arr = [{
				name: '终端',
				path: '/terminalPage',
				icon: 'icon_zd_g@2x',
				iconLight: 'icon_zd_h@2x'
			}, {
				name: '操作日志',
				path: '', // /operationLog
				icon: 'icon_czrz_g@2x',
				iconLight: 'icon_czrz_h@2x'
			}, {
				name: '指令手册',
				path: '/instructionManual',
				icon: 'icon_zlsc_g@2x',
				iconLight: 'icon_zlsc_h@2x'
			}, {
				name: '工具配置',
				path: '', // /toolConfiguration
				icon: 'icon_gjpz_g@2x',
				iconLight: 'icon_gjpz_h@2x'
			}]
		} else if (val === 'taskmaster') {
			arr = [{
				name: '任务中心',
				path: '/taskCenter',
				icon: 'icon_rwzx_g@2x',
				iconLight: 'icon_rwzx_h@2x'
			}, {
				name: '任务队列',
				path: '/taskQueue',
				icon: 'icon_rwdl_g@2x',
				iconLight: 'icon_rwdl_h@2x'
			}, {
				name: '执行记录',
				path: '/executionRecord',
				icon: 'icon_zxjl_g@2x',
				iconLight: 'icon_zxjl_h@2x'
			}, {
				name: '任务配置',
				path: '/taskConfiguration',
				icon: 'icon_rwpz_g@2x',
				iconLight: 'icon_rwpz_h@2x'
			}]
		} else if (val === 'project') {
			arr = [{
				name: '项目中心',
				path: '/projectCenter',
				type: 'track_centre',
				icon: 'icon_xmzx_g@2x',
				iconLight: 'icon_xmzx_h@2x',
			}, {
				name: '我的待办',
				path: '/myToDo',
				type: 'track_todo',
				icon: 'icon_wddb_g@2x',
				iconLight: 'icon_wddb_h@2x'
			}, {
				name: '我的创建',
				path: '/myCreate',
				type: 'track_create',
				icon: 'icon_wdcj_g@2x',
				iconLight: 'icon_wdcj_h@2x'
			}, {
				name: '项目看板',
				path: '', // /projectDashboard
				icon: 'icon_xmkb_g@2x',
				iconLight: 'icon_xmkb_h@2x'
			}, {
				name: '项目配置',
				path: '/projectConfiguration',
				icon: 'icon_xmpz_g@2x',
				iconLight: 'icon_xmpz_h@2x'
			}]
		} else if (val === 'financial') {
			arr = [{
				name: '我要报销',
				path: '/myReimbursement',
				icon: 'icon_wybx_g@2x',
				iconLight: 'icon_wybx_h@2x'
			}, {
				name: '核实报销',
				path: '/verifyReimbursement',
				icon: 'icon_hsbx_g@2x',
				iconLight: 'icon_hsbx_h@2x'
			}, {
				name: '报销记录',
				path: '/reimbursementRecord',
				icon: 'icon_bxjl_g@2x',
				iconLight: 'icon_bxjl_h@2x'
			}, {
				name: '费用存档',
				path: '/expenseArchive',
				icon: 'icon_fycd_g@2x',
				iconLight: 'icon_fycd_h@2x'
			}, {
				name: '财务配置',
				path: '/financialConfiguration',
				icon: 'icon_cwpz_g@2x',
				iconLight: 'icon_cwpz_h@2x'
			}]
		} else if (val === 'server') {
			arr = [{
				name: '服务器监测',
				path: '/serverMonitoring',
				icon: 'icon_fwqjc_g@2x',
				iconLight: 'icon_fwqjc_h@2x'
			}, {
				name: 'ICP备案',
				path: '/ICPFiling',
				icon: 'icon_icpba_g@2x',
				iconLight: 'icon_icpba_h@2x'
			}, {
				name: '域名注册',
				path: '/domainNameRegistration',
				icon: 'icon_ymzc_g@2x',
				iconLight: 'icon_ymzc_h@2x'
			}, {
				name: '轻量应用服务器',
				path: '/lightweightApplicationServer',
				icon: 'icon_qlyyfwq_g@2x',
				iconLight: 'icon_qlyyfwq_h@2x'
			}, {
				name: '证书SSL',
				path: '/certificateSSL',
				icon: 'icon_zsssl_g@2x',
				iconLight: 'icon_zsssl_h@2x'
			}, {
				name: '服务器配置',
				path: '/serverConfiguration',
				icon: 'icon_fwqpz_g@2x',
				iconLight: 'icon_fwqpz_h@2x'
			}]
		} else if (val === 'userAccount') {
			arr = [{
				name: '用户信息',
				path: '/userMess',
				icon: 'icon_yhxx_g@2x',
				iconLight: 'icon_yhxx_h@2x'
			}, {
				name: '用户订单',
				path: '/userOrder',
				icon: 'icon_yhdd_g@2x',
				iconLight: 'icon_yhdd_h@2x'
			}, {
				name: '奖励分配',
				path: '/rewardDistribution',
				icon: 'icon_jlfp_g@2x',
				iconLight: 'icon_jlfp_h@2x'
			}, {
				name: '用户配置',
				path: '/userConfiguration',
				icon: 'icon_yhpz_g@2x',
				iconLight: 'icon_yhpz_h@2x'
			}]
		} else if (val === 'park') {
			arr = [{
				name: 'Park商店',
				path: '/parkStore',
				icon: 'icon_parksd_g@2x',
				iconLight: 'icon_parksd_h@2x'
			}, {
				name: '商店管理',
				path: '/storeManagement',
				icon: 'icon_sdgl_g@2x',
				iconLight: 'icon_sdgl_h@2x'
			}, {
				name: 'Park配置',
				path: '/parkConfiguration',
				icon: 'icon_parkpz_g@2x',
				iconLight: 'icon_parkpz_h@2x'
			}]
		} else if (val === 'help') {
			arr = [{
				name: '入职须知',
				path: '/employmentNotice',
				icon: 'icon_rzxz_g@2x',
				iconLight: 'icon_rzxz_h@2x'
			}, {
				name: '快捷键手册',
				path: '', // /shortcutKeyManual
				icon: 'icon_kjjsc_g@2x',
				iconLight: 'icon_kjjsc_h@2x'
			}, {
				name: '帮助文档',
				path: '', // /helpDocument
				icon: 'icon_bzwd_g@2x',
				iconLight: 'icon_bzwd_h@2x'
			}, {
				name: '更新说明',
				path: '', // /updateExplanation
				icon: 'icon-gxsm-g@2x',
				iconLight: 'icon-gxsm-h@2x'
			}]
		} else if (val === 'resource') {
			arr = [{
				name: '应用程序',
				path: '/applicationProgram',
				icon: 'icon-yycx@2x',
				iconLight: 'icon-yycx-select@2x'
			}, {
				name: '系统装机',
				path: '/systemInstallation',
				icon: 'icon-xtzj@2x',
				iconLight: 'icon-xtzj-select@2x'
			}, {
				name: '脚本工具',
				path: '/scriptingTools',
				icon: 'icon-jbgj@2x',
				iconLight: 'icon-jbgj-select@2x'
			}, {
				name: '文件模版',
				path: '/fileTemplate',
				icon: 'icon-wjmb@2x',
				iconLight: 'icon-wjmb-select@2x'
			}, {
				name: '壁纸',
				path: '/wallpaper',
				icon: 'icon-bz@2x',
				iconLight: 'icon-bz-select@2x'
			}, {
				name: '共享打印',
				path: '/sharedPrinting',
				icon: 'icon-gxdy@2x',
				iconLight: 'icon-gxdy-select@2x'
			}, {
				name: '资源配置',
				path: '/resourceAllocation',
				icon: 'icon_zypz_g@2x',
				iconLight: 'icon_zypz_h@2x'
			}]
		} else if (val === 'path') {
			arr = [{
				name: '路径信息',
				path: '/pathInformation',
				icon: 'icon_ljxx_g@2x',
				iconLight: 'icon_ljxx_h@2x'
			}, {
				name: '路径配置',
				path: '/pathConfiguration',
				icon: 'icon_ljpz_g@2x',
				iconLight: 'icon_ljpz_h@2x'
			}]
		}

		if (val === 'systemNotice') {
			// 获取是否有获取平台消息菜单权限
			getNoticePerssion()
		} else {
			sidebarData.value = arr
		}
	}

	// 获取是否有获取平台消息菜单权限
	function getNoticePerssion() {
		let arr = [{
			name: '站内消息',
			path: '',
			icon: 'icon_znxx_g@2x',
			iconLight: 'icon_znxx_h@2x',
			children: [{
				name: '站内信',
				path: '/mailPage'
			}, {
				name: '公告',
				path: '/bulletinPage'
			}, {
				name: '动态',
				path: '' // /trendsPage
			}]
		}]

		// useUserStore().isHavePerssion 暂时不做修改 此功能没有真正用到 20250807标注 1公版 0内测
		if (!useUserStore().isHavePerssion) {
			arr.push({
				name: '平台消息',
				path: '',
				icon: 'icon_ptxx_g@2x',
				iconLight: 'icon_ptxx_h@2x',
				children: [{
					name: '通告',
					path: '/noticePage'
				}, {
					name: '服务站',
					path: '/serviceStation'
				}]
			})
		}

		arr.push({
			name: '通知配置',
			path: '/noticeSetting',
			icon: 'icon_tzpz_g@2x',
			iconLight: 'icon_tzpz_h@2x'
		})

		sidebarData.value = arr
		// console.log(arr, 'sidebarData.valuesidebarData.value')
	}

	// 根据页面不同类型 获取对应标题+图标
	function sidebarTypeSwitchObj(val) {
		let obj = null
		if (val === 'myMess') {
			obj = {
				name: '我的信息',
				iconShow: initThemeImg(theme.value, 'icon_wdxx_h@2x') // icon-wdxx-select@2x
			}
		} else if (val === 'groupAccount') {
			obj = {
				name: '集团账号',
				iconShow: initThemeImg(theme.value, 'icon_jtzh_h@2x') // icon-jtzh-select@2x
			}
		} else if (val === 'systemNotice') {
			obj = {
				name: '系统通知',
				iconShow: initThemeImg(theme.value, 'icon-xttz@2x')
			}
		} else if (val === 'archive') {
			obj = {
				name: '档案库',
				iconShow: initThemeImg(theme.value, 'icon_dak_h@2x')
			}
		} else if (val === 'toolbox') {
			obj = {
				name: '工具箱',
				iconShow: initThemeImg(theme.value, 'icon_toolbox_h@2x')
			}
		} else if (val === 'taskmaster') {
			obj = {
				name: '任务大师',
				iconShow: initThemeImg(theme.value, 'icon_rwds_h@2x')
			}
		} else if (val === 'project') {
			obj = {
				name: '项目追踪',
				iconShow: initThemeImg(theme.value, 'icon_xmzz_h@2x')
			}
		} else if (val === 'financial') {
			obj = {
				name: '财务范畴',
				iconShow: initThemeImg(theme.value, 'icon_cwfc_h@2x')
			}
		} else if (val === 'server') {
			obj = {
				name: '服务器',
				iconShow: initThemeImg(theme.value, 'icon_fwq_h@2x')
			}
		} else if (val === 'userAccount') {
			obj = {
				name: '用户账号',
				iconShow: initThemeImg(theme.value, 'icon_yhzh_h@2x')
			}
		} else if (val === 'park') {
			obj = {
				name: 'Park公园',
				iconShow: initThemeImg(theme.value, 'icon_parkgy_h@2x')
			}
		} else if (val === 'help') {
			obj = {
				name: '使用帮助',
				iconShow: initThemeImg(theme.value, 'icon_sybz_h@2x')
			}
		} else if (val === 'resource') {
			obj = {
				name: '资源库',
				iconShow: initThemeImg(theme.value, 'icon_zyk_h@2x')
			}
		} else if (val === 'path') {
			obj = {
				name: '定制路径',
				iconShow: initThemeImg(theme.value, 'icon_dzlj_h@2x')
			}
		}
		sidebarObj.value = obj
	}
</script>

<style lang="scss" scoped>
	@import "@/styles/handle.scss";

	.sidebarBloSty {
		flex-shrink: 0;
		box-sizing: border-box;
		transition: width .5s;
		position: sticky;
		left: 0;
		z-index: 3;
		// overflow: hidden;
		height: calc(100vh - #{$navHeight});
		@include background('menu_back');
		@include border-right('border');

		.sidebarObjBlo {
			// display: flex;
			// column-gap: 12px;
			// align-items: center;
			width: 100%;
			font-weight: bold;
			font-size: 16px;
			padding: 16px 0 0 24px;
			box-sizing: border-box;
			overflow: hidden;
			white-space: nowrap;
			height: 52px;
			line-height: 16px;
			@include color('color_FFF');
		}

		// >div:first-child {
		// 	height: 52px;
		// }

		.menuBloSty {
			height: calc(100vh - 104px);
			overflow: auto;
		}
	}

	.transitionParent05 {
		transition: background .5s;

		.isMaskSty {
			transition: background .5s;
		}
	}

	.sidebarBloStyPar {
		position: fixed;
		top: $navHeight;
		left: 0;
		width: 100%;
		height: calc(100% - #{$navHeight});
		z-index: 998;
	}

	.positionA {
		position: absolute;
	}

	.zIndex998 {
		z-index: 998;
	}

	.width244 {
		width: 244px;
	}

	.width64 {
		// width: 64px;
		width: 0px;
		@include border-right('el-input__wrapper_border_none');
	}

	::-webkit-scrollbar {
		display: none;
	}

	.isExpandSty {
		width: 12px;
		height: 200px;
		display: flex;
		cursor: pointer;
		align-items: center;
		justify-content: center;
		border-radius: 0 4px 4px 0;

		.isExpandIcon {
			width: 6px;
			height: 12px;
		}
	}

	.isExpandStyBack {
		@include background('is_expand_back');
	}

	.isExpandStyIsMixed {
		background: #DEDEDE;
	}
</style>